var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AlertCard',{attrs:{"icon":"error_outline","text":_vm.$t('errors.loading.description'),"subtext":_vm.$t('errors.loading.suggestion')}})
}
var staticRenderFns = []

export { render, staticRenderFns }